"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var utilities_1 = require("@hsl-fi/utilities");
var Shimmer_module_scss_1 = __importDefault(require("./Shimmer.module.scss"));
var classList = utilities_1.PropertyUtilities.classList;
var variantStyleMap = {
    white: Shimmer_module_scss_1.default.shimmerWhite,
    grey: Shimmer_module_scss_1.default.shimmerGrey
};
var Shimmer = function (_a) {
    var active = _a.active, children = _a.children, className = _a.className, _b = _a.variant, variant = _b === void 0 ? 'white' : _b;
    return (react_1.default.createElement("div", { className: Shimmer_module_scss_1.default.shimmerContainer },
        children,
        react_1.default.createElement("div", { className: classList(Shimmer_module_scss_1.default.shimmer, variantStyleMap[variant], active && Shimmer_module_scss_1.default.shimmerVisible, className) })));
};
exports.default = Shimmer;
